import { render } from "./TournamentEditPage.vue?vue&type=template&id=b8da73da"
import script from "./TournamentEditPage.vue?vue&type=script&lang=js"
export * from "./TournamentEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__